import { Injectable } from "@angular/core";
import { ErrorMessageService } from "app/core/error-message.service";
import { ApiService } from "app/shared/security/api-services/api.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Status } from "../../models/status";
import { StatusApi } from "./status-api.models";

@Injectable()
export class StatusApiService extends StatusApi {
  private _endpointPath: string =
    environment.apiHost + "/v1/workorders/statuses";

  constructor(
    private apiService: ApiService,
    private errorMessageService: ErrorMessageService,
  ) {
    super();
  }

  public getPredefinedStatuses() {
    return this.apiService.get<{ items: Status[] }>(this._endpointPath).pipe(
      map((res) => res.items || []),
      tap(
        (res) => res,
        (error) => this.errorMessageService.notifyError(error),
      ),
    );
  }
}
